/**
 * Developer mode: unlocks debug tools during play — SISSI (reveal everything),
 * switching fog/free visibility mid-match, the F3 frame profiler and the
 * backtick cheat console. A persisted per-browser setting; on by default while
 * the game is in development. Never touches game state.
 */

const STORAGE_KEY = 'orbituary-dev-mode';

function load(): boolean {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === null ? true : v === '1';
  } catch { return true; }
}

let enabled = load();
const listeners = new Set<() => void>();

export function isDevMode(): boolean { return enabled; }

export function setDevMode(v: boolean): void {
  enabled = v;
  try { localStorage.setItem(STORAGE_KEY, v ? '1' : '0'); } catch { /* storage unavailable */ }
  updateDevToggles();
  for (const l of listeners) l();
}

export function onDevModeChange(cb: () => void): () => void {
  listeners.add(cb);
  return () => { listeners.delete(cb); };
}

/** Every dev toggle button shows the state; every `.dev-only` element shows or hides. */
export function updateDevToggles(): void {
  for (const el of Array.from(document.querySelectorAll<HTMLElement>('.setting-dev'))) {
    el.textContent = enabled ? 'ON' : 'OFF';
    el.classList.toggle('off', !enabled);
  }
  for (const el of Array.from(document.querySelectorAll<HTMLElement>('.dev-only'))) {
    el.style.display = enabled ? '' : 'none';
  }
}
